import { jsxs as e, jsx as u } from "react/jsx-runtime";
import b from "react";
import { ButtonVariant as n } from "./ButtonVariant.type.mjs";
import { ButtonModifiers as o } from "./ButtonModifiers.type.mjs";
const g = b.forwardRef(
  ({
    type: l = "button",
    disabled: r,
    variant: p,
    className: s,
    isLoading: h,
    modifiers: a,
    children: B,
    onClick: d,
    testId: c,
    ...L
  }, i) => {
    const t = ["Button"];
    switch (p) {
      case n.LINK:
        t.pop(), t.push("Link");
        break;
      case n.SECONDARY:
        t.push("Button--secondary"), t.push("Button--secondary--action-blue");
        break;
      case n.TERTIARY:
        t.push("Button--tertiary");
        break;
      case n.DELETE:
        t.push("Button--delete");
        break;
      case n.PRIMARY:
      default:
        t.push("Button--primary");
        break;
    }
    return a != null && a.includes(o.BLOCK) && t.push("Button--block"), a != null && a.includes(o.SMALL) && t.push("Button--small"), a != null && a.includes(o.REVERSED) && t.push("Button--reversed"), s && t.push(s), /* @__PURE__ */ e(
      "button",
      {
        type: l,
        ...L,
        onClick: d,
        ref: i,
        disabled: r,
        className: t.join(" "),
        "data-testid": c || null,
        children: [
          B,
          h && /* @__PURE__ */ e("div", { className: "u-marginLeft8 Loading Loading--small", children: [
            /* @__PURE__ */ u("div", { className: "Loading-indicator" }),
            /* @__PURE__ */ u("div", { className: "Loading-indicator" }),
            /* @__PURE__ */ u("div", { className: "Loading-indicator" })
          ] })
        ]
      }
    );
  }
);
export {
  g as Button
};
//# sourceMappingURL=Button.mjs.map
